import { useEffect } from "react";

/**
 * Hides the site-wide Ebanqo chat widget (injected in public/index.html) for
 * as long as the calling route is mounted, and restores it on unmount — the
 * CTO's position is that Ebanqo stays maintained site-wide, so this is per
 * route and never global.
 *
 * Used where the widget's launcher and prompt bubble sit on top of the
 * route's own controls: the MTN campaign chat (it covered the send button at
 * the conversion moment, product decision 2026-08-20) and the games, where it
 * covers the board.
 *
 * @param marker value for the style tag's data attribute, so it is obvious in
 *               the DOM which route hid the widget.
 */
export function useHideEbanqoWidget(marker: string): void {
  useEffect(() => {
    const style = document.createElement("style");
    style.setAttribute("data-ebanqo-hide", marker);
    style.textContent =
      ".ebanqo-widget, .initial-prompt-message-wrapper { display: none !important; }";
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, [marker]);
}
